import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { useAuth } from '../context/AuthContext';

export function getSharedLinkGateView({ loading, currentUser }) {
  if (loading) return 'loading';
  return currentUser ? 'full' : 'preview';
}

export function isSafeInternalReturnPath(path) {
  return typeof path === 'string' && path.startsWith('/') && !path.startsWith('//');
}

export default function SharedLinkGate({ children, preview }) {
  const { currentUser, loading } = useAuth();
  const view = getSharedLinkGateView({ loading, currentUser });

  if (view === 'loading') {
    return (
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          bgcolor: '#008080',
          color: 'white',
        }}
      >
        <Box sx={{ textAlign: 'center' }}>
          <CircularProgress sx={{ color: 'white', mb: 2 }} />
          <Typography variant="h6">Loading...</Typography>
        </Box>
      </Box>
    );
  }

  return view === 'full' ? children : preview;
}
